import DashboardWrapper from "./DashboardWrapper";

export default DashboardWrapper;
